export const HTMLFontSize = 16 as const;

export const RefreshTokenErrorMessage = "Refresh token does not exist" as const;
